import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('geometryShapesCidadeArea');

export const check = () => useBasicAuth.checkToken();

export const findAllGeometryAreaByEstado = (id) => 
  axios.get(urlAPI + "/byEstado/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeometryAreaByCidade = (id) => 
  axios.get(urlAPI + "/byCidade/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeometryAreaByCidadeVizinha = (cidade) => 
  axios.post(urlAPI + "/byCidadeVizinha", JSON.stringify(cidade), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });